import PropTypes from 'prop-types';

// material-ui
import { useTheme, styled } from '@mui/material/styles';
import { Box, Drawer, useMediaQuery } from '@mui/material';
import { useDispatch } from 'react-redux';
// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
import { BrowserView, MobileView } from 'react-device-detect';

// project imports
import MenuList from './MenuList';
import LogoSection from '../LogoSection';
import MenuCard from './MenuCard';
import { drawerWidth } from 'store/constant';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';

const ApplyServiceButton = styled(Button)(() => ({
    textTransform: 'none',
    backgroundColor: '#A6CFA3',
    color: '#000',
    '&:hover': {
        backgroundColor: '#59A831',
        color: '#fff'
    }
}));
// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = ({ drawerOpen, drawerToggle, window }) => {
    const theme = useTheme();
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch({ type: SET_MENU, opened: false });
    };

    const drawer = (
        <>
            <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                <Box sx={{ display: 'flex', p: 2, mx: 'auto' }}>
                    <LogoSection />
                </Box>
            </Box>
            <BrowserView>
                <PerfectScrollbar
                    component="div"
                    style={{
                        height: !matchUpMd ? 'calc(100vh - 56px)' : 'calc(100vh - 88px)',
                        paddingLeft: '16px',
                        paddingRight: '16px'
                    }}
                >
                    <MenuList />
                </PerfectScrollbar>
            </BrowserView>
            <MobileView>
                <Box sx={{ px: 2 }}>
                    <Box sx={{ textAlign: 'center', p: '0px', display: { xs: 'block', md: 'none' } }}>
                        <Box sx={{ pb: 2 }}>
                            <Link
                                to="/pieteikt-pakalpojumu"
                                style={{ textDecoration: 'none', textTransform: 'none' }}
                                onClick={handleClick}
                            >
                                <ApplyServiceButton variant="contained" sx={{ width: '100%' }}>
                                    Jauns pakalpojums
                                </ApplyServiceButton>
                            </Link>
                        </Box>
                        <Box component="span" sx={{ display: { xs: 'block', md: 'block' }, pb: 2 }}>
                            <Link to="/addresses" style={{ textDecoration: 'none', textTransform: 'none' }} onClick={handleClick}>
                                <Button variant="contained" sx={{ textTransform: 'none', width: '100%' }}>
                                    Izmaiņas esošā pakalpojumā
                                </Button>
                            </Link>
                        </Box>
                    </Box>
                    <MenuList />
                </Box>
            </MobileView>
        </>
    );

    const container = window !== undefined ? () => window.document.body : undefined;

    return (
        <Box component="nav" sx={{ flexShrink: { md: 0 }, width: matchUpMd ? drawerWidth : 'auto' }} aria-label="mailbox folders">
            <Drawer
                container={container}
                variant={matchUpMd ? 'persistent' : 'temporary'}
                anchor="left"
                open={drawerOpen}
                onClose={drawerToggle}
                sx={{
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        background: theme.palette.background.default,
                        color: theme.palette.text.primary,
                        borderRight: 'none',
                        [theme.breakpoints.up('md')]: {
                            top: '88px'
                        }
                    }
                }}
                ModalProps={{ keepMounted: true }}
                color="inherit"
            >
                {drawer}
            </Drawer>
        </Box>
    );
};

Sidebar.propTypes = {
    drawerOpen: PropTypes.bool,
    drawerToggle: PropTypes.func,
    window: PropTypes.object
};

export default Sidebar;
